import loginPageStyles from "../../styles/login.module.css";

export default function AppChip({
  Icon,
  title
}: {
  Icon: React.ElementType;
  title: string;
}) {
  return (
    <div className={loginPageStyles.appChip}>
      <Icon width={100} height={100} />
      <p className={loginPageStyles.moduleTitle}>{title}</p>
    </div>
  );
}
